/**
 * Factory to return ITelemetryLogger objects
 */

import { TelemetrySink } from "@microsoft/oteljs";
import { App, Browser, Device, Host, Release, Session } from "./Contracts";
import ITelemetryLogger from "./ITelemetryLogger";
import OtelTelemetryLogger from "./OtelTelemetryLogger";

export default class TelemetryLoggerFactory {
	public static create(tenantToken: string, namespace: string, telemetrySink: TelemetrySink, app: App, session: Session,
		host: Host, release: Release, browser: Browser, device: Device): ITelemetryLogger {
			return new OtelTelemetryLogger(tenantToken, namespace, telemetrySink, app, session, host, release, browser, device);
		}
}
